import { EMessageType } from '../enums/message-outbox.enum';

export const MESSAGE_TYPES = {
  [EMessageType.PaymentNoti]: {
    id: EMessageType.PaymentNoti,
    value: EMessageType.PaymentNoti,
    viewValue: 'Payment Notifications',
    hideFilter: false,

  },
  [EMessageType.ResaleInvoice]: {
    id: EMessageType.ResaleInvoice,
    value: EMessageType.ResaleInvoice,
    viewValue: 'Resale Invoice',
    hideFilter: true,

  },
  [EMessageType.StatementOfAccount]: {
    id: EMessageType.StatementOfAccount,
    value: 'EMessageType.StatementOfAccount',
    viewValue: 'SOA',
    hideFilter: false,

  },
};

